window.Helpers =
  react_component: ($$, $this) ->
    React = require('react')
    ReactDOM = require('react-dom/client')
    component = require('../javascript/react/' + $this.data('name')).default
    root = ReactDOM.createRoot($this[0])
    root.render(React.createElement(component, $this.data('props'), null))
